import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import styled from "styled-components";
import theme from "../../theme";
import { NokCrudType } from "../../types/types";
import InputField from "./inputField";
import usePostNok from "../../hooks/usePostNok";
import { isOnlyNumber } from "../../utils/util";
import AlertModal from "../alertModal";
import { WarningIcon } from "../../assets/icons/icons";
import { Button } from "../common/Button";
import { ModalLayout } from "../common/ModalLayout";
import { useSnackbar } from "notistack";
import { useWindowSize } from "@reactuses/core";
import { useI18n } from "../../locales";

const { md } = theme.screen;

const NokRegisterModal: React.FC<{
  open: boolean;
  onPressNo: () => void;
}> = (props) => {
  const { open, onPressNo } = props;
  const { width } = useWindowSize();
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useI18n();
  const queryClient = useQueryClient();
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [form, setForm] = useState<NokCrudType>({
    name: "",
    id: "",
    related_id: "-1",
    relation: "",
  });

  const { mutate: postNok, isPending } = usePostNok();

  const handlePost = () => {
    postNok(form, {
      onSuccess: async (data) => {
        closeToModal();
        queryClient.invalidateQueries({ queryKey: ["Nok"] });
        enqueueSnackbar(t.manageNok.registerSuccess, {
          variant: "success",
        });
        return data;
      },
    });
  };

  // 모달 닫기 함수
  const closeToModal = () => {
    setOpenConfirmModal(false);
    onPressNo();
    setForm({
      name: "",
      id: "",
      related_id: "-1",
      relation: "",
    });
  };

  // 필수 입력 조건
  const isAllFilled =
    [form.name, form.id, form.related_id, form.relation].every(
      (el) => el !== ""
    ) &&
    form.related_id != "-1" &&
    form.id.length >= 10 &&
    isOnlyNumber(form.id);

  return (
    <ModalLayout
      open={open}
      onClose={() => setOpenConfirmModal(true)}
      width="550px"
      title={t.manageNok.registerRecipientTitle}
    >
      <InputField form={form} setForm={setForm} />

      <BtnWrapper>
        <Button
          onClick={() => handlePost()}
          bgColor={theme.statusColor.MAIN}
          hoverColor={theme.statusColor.MAIN_HOVER}
          isDisabled={!isAllFilled}
          isLoading={isPending}
        >
          {width <= md ? t.common.register : t.manageNok.registerRecipient}
        </Button>
        <Button
          bgColor={theme.statusColor.CLOSE}
          onClick={() => setOpenConfirmModal(true)}
          hoverColor={theme.statusColor.CLOSE_HOVER}
        >
          {t.common.cancel}
        </Button>
      </BtnWrapper>
      <AlertModal
        open={openConfirmModal}
        onPressNo={() => setOpenConfirmModal(false)}
        title={t.manageNok.cancelRegisterTitle}
        content={t.manageNok.cancelRegisterContent}
        confirmText={t.common.confirm}
        icon={<WarningIcon />}
        onPressYes={closeToModal}
      />
    </ModalLayout>
  );
};

const BtnWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 20px;
  margin: 0 50px;
  margin-top: 20px;

  button {
    width: 270px;
  }
  @media (max-width: ${md}px) {
    margin: 0px;
    margin-top: 20px;
  }
`;

export default NokRegisterModal;
